/**
 * Removes "(Translated by Google)" text and everything after it from a review comment
 * First removes everything before "(Original)" if it exists, then removes "(Translated by Google)" and everything after it
 * @param {string} text - The text that may contain Google translation marker
 * @returns {string} The text without the translation marker and translated content
 */
export const removeGoogleTranslation = (text) => {
    if (!text) return text;
    
    // First, if "(Original)" exists, remove everything before it
    const originalIndex = text.indexOf("(Original)");
    if (originalIndex !== -1) {
        text = text.substring(originalIndex + 10); // 10 is the length of "(Original)"
        text = text.trim();
    }
    
    // Then, remove "(Translated by Google)" and everything after it if it still exists
    const translatedByGoogleIndex = text.indexOf("(Translated by Google)");
    if (translatedByGoogleIndex !== -1) {
        return text.substring(0, translatedByGoogleIndex).trim();
    }
    
    return text;
}

export default removeGoogleTranslation;

